import createSagaMiddleware from "redux-saga";
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk';
import rootSaga from "../sagas/index";
import createRootReducer from '../reducers'
import axios from 'axios';
import axiosMiddleware from "redux-axios-middleware";
import { BASE_URL,TIME_TO_UPDATE_TOKEN } from '../../constants/Config'
import { AxiosFetchStart, AxiosFetchSuccess, AxiosFetchError } from '../actions/LoadingCenter'
import { setCompanyPaymentBlocked, userSignOut } from "appRedux/actions/Auth";
import moment from 'moment'
import { UpdateTokenRequest } from '../actions/Axios'
import { COMPANY_SELECTION_REQUIRED, installCompanyPaymentInterceptor, isCompanyRecoveryPath, isSameCompanySession, readBlockedCompany, setCompanyPaymentHandler } from '../../util/companyPaymentAccess';
const createBrowserHistory = require('history').createBrowserHistory;


export const history = createBrowserHistory();

const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();


const Axios_Client = axios.create({ //all axios can be used, shown in axios documentation
  baseURL: `${BASE_URL}/api`,
  responseType: 'json'
});

const middlewareConfig = {
  returnRejectedPromiseOnError: true,
  // onSuccess:function(Info){
  //   //dispatch(AxiosFetchStart())
  //   console.log(Info)
  //   return Info;
  // },
  onError: function (Info) {
    const { response, message } = Info.error;
    const status = response?.status;
    const selectorSearch = Info.action?.payload?.request?.selectorSearch || Info.error.config?.selectorSearch;
    if (!selectorSearch) {
      Info.dispatch(AxiosFetchError(message));
    }


    if (status === 401)
      Info.dispatch(userSignOut());

    return (Info) ;
  },

  onComplete: function (Info) {
    if (readBlockedCompany() || isCompanyRecoveryPath(history.location.pathname)) return Info;
    const ExpirationDate = localStorage.getItem('expiration');
    if (ExpirationDate == null)
      return Info;
    var momentDate = moment(new Date(ExpirationDate));
    var duration = moment.duration(momentDate.diff(moment(new Date())));
    var minutes = duration.asMinutes();
    if (minutes <= TIME_TO_UPDATE_TOKEN && minutes > 0) {
      UpdateTokenRequest(({ token, expiration }) => {
        localStorage.removeItem('token');
        localStorage.removeItem('expiration');
        localStorage.setItem('token', token);
        localStorage.setItem('expiration', expiration);
      })
    }
    return Info;
  },
  interceptors: {
    request: [{
      success: function ({ getState, dispatch, getSourceAction }, req) {
        //const {auth} =getState();
        req.headers.Authorization = 'Bearer ' + localStorage.getItem("token");
        req.headers['Content-Type'] = 'application/json';
        req.headers['Access-Control-Allow-Origin'] = '*';
        req.headers['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';
        
        //if(req.params.NOTSHOWLOADING!==true)
          if (!req.selectorSearch) dispatch(AxiosFetchStart())
          
        return req;
      },
      error: function ({ getState, dispatch, getSourceAction }, error) {
        //console.log("Request ",error)
        return Promise.reject(error);
      }
    }
    ],
    response: [{
      success: function ({ getState, dispatch, getSourceAction }, response) {
        if (!response.config?.selectorSearch) dispatch(AxiosFetchSuccess());
        return response;
      },
      error: function ({ getState, dispatch, getSourceAction }, error) {
        return Promise.reject(error);
      }
    }
    ]
  }
};

const middlewares = [thunk, sagaMiddleware, routeMiddleware, axiosMiddleware(Axios_Client, middlewareConfig)];
let removePaymentInterceptors = () => {};

export default function configureStore(preloadedState) {
  const store = createStore(
    createRootReducer(history), // root reducer with router state
    preloadedState,
    compose(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        ...middlewares
      ),
    ),
  );

  removePaymentInterceptors();
  const onPaymentBlocked = (company, error) => {
    const token = localStorage.getItem('token');
    const requestToken = error.config?.headers?.Authorization;
    if (!token || (requestToken && !isSameCompanySession(requestToken.replace(/^Bearer\s+/i, ''), token))) return;
    if (company.errorCode === COMPANY_SELECTION_REQUIRED) {
      if (history.location.pathname !== '/companyGroup') history.replace('/companyGroup');
      return;
    }
    store.dispatch(setCompanyPaymentBlocked(company));
  };
  setCompanyPaymentHandler(onPaymentBlocked);
  const removeDefaultInterceptor = installCompanyPaymentInterceptor(axios, onPaymentBlocked);
  const removeReduxInterceptor = installCompanyPaymentInterceptor(Axios_Client, onPaymentBlocked);
  removePaymentInterceptors = () => {
    removeDefaultInterceptor();
    removeReduxInterceptor();
  };

  sagaMiddleware.run(rootSaga);
  return store;
}
